import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { BrandCardHeader } from "#/components/brand/BrandCardHeader";
import { Button } from "#/components/ui/button";
import { Card, CardContent } from "#/components/ui/card";
import { Input } from "#/components/ui/input";
import { StatusMessage } from "#/components/ui/status-message";
import { formatSchemaError, getFieldSchema, isSchemaError, parseSchema, validateField } from "#/lib/validation";
import { LoadingButton } from "#components/ui/loading-button.jsx";
import { passwordSchema } from "./ChangePasswordCard.schema";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ChangePasswordCard({
  handlePasswordUpdate,
  onBack,
  statusMessage,
  isLoading = false
}) {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [errors, setErrors] = useState({});
  const validateFormField = (name, value) => {
    const fieldSchema = getFieldSchema(passwordSchema, name);
    if (fieldSchema) {
      const error = validateField(fieldSchema, value);
      if (error) {
        setErrors(prev => ({
          ...prev,
          [name]: error
        }));
      } else {
        setErrors(prev_0 => {
          const {
            [name]: _,
            ...rest
          } = prev_0;
          return rest;
        });
      }
    }
  };
  const handleChange = (name_0, value_0) => {
    setFormData(prev_1 => ({
      ...prev_1,
      [name_0]: value_0
    }));
    validateFormField(name_0, value_0);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const validatedData = parseSchema(passwordSchema, formData);
      const response = await handlePasswordUpdate(validatedData.currentPassword, validatedData.newPassword);
      if (!response.success) {
        setErrors({
          form: response.message
        });
      }
    } catch (error_0) {
      if (isSchemaError(error_0)) {
        setErrors(formatSchemaError(error_0));
      }
    }
  };
  return /*#__PURE__*/_jsxs(Card, {
    className: "m-auto w-screen overflow-y-auto rounded-none bg-card shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
    children: [/*#__PURE__*/_jsx(BrandCardHeader, {
      title: "\xC4ndra l\xF6senord",
      subtitle: "V\xE4lj ett nytt l\xF6senord f\xF6r ditt konto"
    }), /*#__PURE__*/_jsx(CardContent, {
      className: "space-y-6 p-6",
      children: /*#__PURE__*/_jsxs("form", {
        onSubmit: handleSubmit,
        className: "space-y-4",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "space-y-2",
          children: [/*#__PURE__*/_jsx(Input, {
            type: "password",
            placeholder: "Nuvarande l\xF6senord",
            value: formData.currentPassword,
            onChange: e_0 => handleChange("currentPassword", e_0.target.value),
            error: errors.currentPassword
          }), /*#__PURE__*/_jsx(Input, {
            type: "password",
            placeholder: "Nytt l\xF6senord",
            value: formData.newPassword,
            onChange: e_1 => handleChange("newPassword", e_1.target.value),
            error: errors.newPassword
          }), /*#__PURE__*/_jsx(Input, {
            type: "password",
            placeholder: "Bekr\xE4fta nytt l\xF6senord",
            value: formData.confirmPassword,
            onChange: e_2 => handleChange("confirmPassword", e_2.target.value),
            error: errors.confirmPassword
          })]
        }), (errors.form || statusMessage) && /*#__PURE__*/_jsx(StatusMessage, {
          message: errors.form || statusMessage?.message || "",
          variant: errors.form ? "error" : statusMessage?.variant || "error"
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/*#__PURE__*/_jsx(LoadingButton, {
            type: "submit",
            loading: isLoading,
            children: "Spara l\xF6senord"
          }), /*#__PURE__*/_jsxs(Button, {
            type: "button",
            variant: "outline",
            onClick: onBack,
            disabled: isLoading,
            children: [/*#__PURE__*/_jsx(ArrowLeft, {
              className: "mr-2 h-4 w-4"
            }), "Tillbaka"]
          })]
        })]
      })
    })]
  });
}